import {CacheKey, Deserializer, JsonIgnore, JsonProperty, ObjectMapper, Serializer} from "json-object-mapper";

export class NesterFieldDataConfig {
  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "data_type"})
  public dataType?: string = undefined;

  @JsonProperty({name: "required"})
  public required?: number = undefined;

  @JsonProperty({name: "selector"})
  public selector?: string = undefined;

}

@CacheKey("ArrayNesterFieldDataConfigSerializerDeserializer")
export class ArrayNesterFieldDataConfigSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): NesterFieldDataConfig[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(NesterFieldDataConfig, v);
    })
  }
  serialize = (values: NesterFieldDataConfig[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class FieldDataConfig {
  @JsonProperty({name: "name"})
  public name?: string = undefined;

  @JsonProperty({name: "data_type"})
  public dataType?: string = undefined;

  @JsonProperty({name: "required"})
  public required?: number = undefined;

  @JsonProperty({name: "selector"})
  public selector?: string = undefined;

  @JsonProperty({name: "hash"})
  public hash?: string = undefined;

  @JsonProperty({name: "regex"})
  public regex?: string = undefined;

  @JsonProperty({name: "ngram"})
  public ngram?: number = undefined;

  @JsonProperty({name: "rows"})
  public rows?: number = undefined;

  @JsonProperty({name: "bands"})
  public bands?: number = undefined;

  @JsonProperty({name: "list"})
  public list?: string = undefined;

  @JsonProperty({name: "mapping"})
  public mapping?: string = undefined;

  @JsonProperty({
    type: NesterFieldDataConfig,
    deserializer: ArrayNesterFieldDataConfigSerializerDeserializer,
    name: "fields"
  })
  public fields?: NesterFieldDataConfig[] = [];
}

@CacheKey("ArrayFieldDataConfigSerializerDeserializer")
export class ArrayFieldDataConfigSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): FieldDataConfig[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(FieldDataConfig, v);
    })
  }
  serialize = (values: FieldDataConfig[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class FieldDataRequestParams {
  @JsonProperty({name: "threshold"})
  threshold: number = 0.0;
}

@CacheKey("ArraySingleLookupRequestFieldDataSerializerDeserializer")
export class ArraySingleLookupRequestFieldDataSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): SingleLookupRequestFieldData[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(SingleLookupRequestFieldData, v);
    })
  }
  serialize = (values: SingleLookupRequestFieldData[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class SingleLookupRequestFieldData {
  @JsonProperty({name: "name"})
  name?: string = undefined;

  @JsonProperty({name: "value"})
  value?: string = undefined;

  @JsonIgnore()
  config?: FieldDataConfig

  @JsonProperty({type: FieldDataRequestParams, name: "params"})
  params: FieldDataRequestParams
}

export class SingleLookupRequest {
  @JsonProperty({name: "data_owner"})
  dataOwner?: string = undefined;

  @JsonProperty({name: "data_vertical"})
  dataVertical?: string = undefined;

  @JsonProperty({type: FieldDataConfig, name: "data_code"})
  dataCode?: string = undefined

  @JsonProperty({
    type: SingleLookupRequestFieldData,
    deserializer: ArraySingleLookupRequestFieldDataSerializerDeserializer,
    name: "fields"
  })
  fields: SingleLookupRequestFieldData[] = []

}

export class FieldData {
  @JsonProperty({name: "record"})
  record?: string = undefined;

  @JsonProperty({name: "value"})
  value?: string = undefined;

  @JsonProperty({name: "owner"})
  owner?: string = undefined;

  @JsonProperty({name: "vertical"})
  vertical?: string = undefined;

  @JsonProperty({name: "code"})
  code?: string = undefined;

  @JsonProperty({type: FieldDataConfig, name: "config"})
  config?: FieldDataConfig = undefined

  @JsonProperty({type: FieldDataRequestParams, name: "params"})
  params?: FieldDataRequestParams = undefined
}

@CacheKey("ArrayFieldDataSerializerDeserializer")
export class ArrayFieldDataSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): FieldData[] => {
    return values.map(v => {
      return ObjectMapper.deserialize(FieldData, v);
    })
  }
  serialize = (values: FieldData[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}

export class DataEntry {

  @JsonProperty({name: "owner"})
  owner?: string = undefined;

  @JsonProperty({name: "vertical"})
  vertical?: string = undefined;

  @JsonProperty({name: "code"})
  code?: string = undefined;

  @JsonProperty({name: "label"})
  label?: string = undefined;

  @JsonProperty({name: "record"})
  record?: string = undefined;

  @JsonProperty({name: "entry"})
  entry?: string = undefined;

  @JsonProperty({type: FieldData, deserializer: ArrayFieldDataSerializerDeserializer, name: "data"})
  data: FieldData[] = []

}
